module.exports = "<!-- Pestañas -->\n<div class=\"shortcuts\">\n  <tabset>\n    <tab id=\"tab-flow\">\n      <ng-template tabHeading>\n        <span style=\"font-size: 0.8em !important;\">\n          <i class=\"fa fa-code-fork\"></i>\n          Flujo\n        </span>\n      </ng-template>\n      <!-- Flujo de actividades y tareas -->\n      <iw-flow></iw-flow>\n    </tab>\n  </tabset>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main